import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { myorderslist } from "../../Apiservices/Auth/Myorders/Myordersapi";
import { addServiceToCart } from "../../store/cartbodydataslice";
import { addToCart } from "../../store/cartSlice";

export default function useMyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
 
 const populateCartFromOrders = (ordersData) => {
  (ordersData.upcoming || []).forEach((event) => {
    const eveId = event.event_id;
    const eventname = event.event_title;
    const event_start_date = event.event_start_date;

    // Priest
    event.priestdata?.forEach((priestItem) => {
      const provider = priestItem.priest;
      const service = priestItem.service;

      // Add to cartbodySlice
      dispatch(
        addServiceToCart({
          eveId,
          eventname,
          event_start_date,
          type: "priestData",
          item: {
            ...priestItem,
            provider_id: provider.id,
            providername: provider.name,
            mobileNumber: provider.mobileNumber,
            price: priestItem.total_amount,
            discountPrice: priestItem.discountPrice,
            validUpto: priestItem.validUpto,
            service_id: service.id,
            cart_id: priestItem.id,
            is_checked_out: priestItem.is_checked_out,
            is_edit_allowed: priestItem.is_edit_allowed,
            paid_amount: priestItem.paid_amount,
            balance_to_be_paid: priestItem.balance_to_be_paid,
            is_cancel_in_progress: priestItem.is_cancel_in_progress,
            is_canceled: priestItem.is_canceled,
            refund_complete: priestItem.refund_complete,
            refund_in_pending: priestItem.refund_in_pending,
            refunded_amount: priestItem.refunded_amount,
          },
        })
      );

      // Add to new cartSlice
      dispatch(
        addToCart({
          serviceType: "preist",
          eventID: eveId,
          providerID: provider.id,
          service_id: service.id,
          price: priestItem.total_amount,
          discountprice: priestItem.discountPrice,
          discountvalidupto: priestItem.validUpto,
          is_checked_out: true ,
          quantity: 1,
          cart_id: priestItem.id,
        })
      );
    });

    // Tent House
    event.tentproviderdata?.forEach((tentItem) => {
      dispatch(
        addServiceToCart({
          eveId,
          eventname,
          event_start_date,
          type: "tentHouseData",
          item: {
            ...tentItem,
            provider_id: tentItem.provider_id,
            providername: `${tentItem.first_name} ${tentItem.last_name}`,
            balance_to_be_paid: tentItem.balance_to_be_paid,
            is_checked_out: tentItem.is_checked_out,
            is_edit_allowed: tentItem.is_edit_allowed,
            paid_amount: tentItem.paid_amount,
            services: tentItem.items.map((item) => ({
              ...item,
              cart_id: item.tent_cart_item_id,
              mapping_id: item.mapping_id,
              service_id: item.service_id,
              quantity: item.quantity,
              price: item.price,
              discountPrice: item.discount_price,
              validUpto: item.discount_valid_upto,
            })),
            is_cancel_in_progress: tentItem.is_cancel_in_progress,
            is_canceled: tentItem.is_canceled,
            refund_complete: tentItem.refund_complete,
            refund_in_pending: tentItem.refund_in_pending,
            refunded_amount: tentItem.refunded_amount,
          },
        })
      );

      // Add to new cartSlice (one provider per event)
      dispatch(
        addToCart({
          serviceType: "tenthouse",
          eventID: eveId,
          providerID: tentItem.provider_id,
          service_id: null, // optional if not relevant
          price: null,
          discountprice: null,
          discountvalidupto: null,
          quantity: null,
          cart_id: null,
          is_checked_out: true ,
        })
      );
    });

    // Catering
    event.cateringproviderdata?.forEach((cateringItem) => {
      dispatch(
        addServiceToCart({
          eveId,
          eventname,
          event_start_date,
          type: "cateringData",
          item: {
            ...cateringItem,
            provider_id: cateringItem.provider_id,
            providername: `${cateringItem.first_name} ${cateringItem.last_name}`,
            balance_to_be_paid: cateringItem.balance_to_be_paid,
            is_checked_out: cateringItem.is_checked_out,
            is_edit_allowed: cateringItem.is_edit_allowed,
            paid_amount: cateringItem.paid_amount,
            services: cateringItem.items.map((item) => ({
              ...item,
              mapping_id: item.item_id,
              service_id: item.category_id,
              quantity: item.number_of_people,
              price: item.regular_price,
              discountPrice: item.discounted_price,
              validUpto: item.valid_until,
              category: item.category.category_name,
              mealtype: item.meal.meal_name,
              cuisine: item.type.type_name,
            })),
            is_cancel_in_progress: cateringItem.is_cancel_in_progress,
            is_canceled: cateringItem.is_canceled,
            refund_complete: cateringItem.refund_complete,
            refund_in_pending: cateringItem.refund_in_pending,
            refunded_amount: cateringItem.refunded_amount,
          },
        })
      );

      // Add to new cartSlice (array for catering)
      cateringItem.items.forEach((item) => {
        dispatch(
          addToCart({
            serviceType: "catering",
            eventID: eveId,
            providerID: cateringItem.provider_id,
            service_id: item.category_id,
            mapping_id: item.item_id,
            price: item.regular_price,
            discountprice: item.discounted_price,
            discountvalidupto: item.valid_until,
            quantity: item.number_of_people,
            cart_id: null,
            is_checked_out: true ,
          })
        );
      });
    });
  });
};


  const fetchMyOrdersList = useCallback(async () => {
    setLoading(true);
    try {
      const response = await myorderslist();
      const data = response?.data || {};
      
      setOrders(data);
      populateCartFromOrders(data);
    } catch (err) {
      console.error("Couldn't get the list of my orders", err);
      setError("Failed to fetch orders. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchMyOrdersList();
  }, [fetchMyOrdersList]);

  const refreshMyOrders = () => fetchMyOrdersList();

  return { orders, loading, error, refreshMyOrders };
}
